module.exports = __webpack_public_path__ + "img/pro.0feca846.svg";